import styled from 'styled-components';

export const MaskedHeaderScrollIndicatorWrapper = styled.div`
    position: absolute;
    overflow: visible;
    z-index: 11;
    width: 100%;
    .above-fold-hint {
        top: 97vh;
        left: 0;
        right: 0;
        text-align: center;
        margin: 0 auto;
        position: fixed;
    }

    &.hide {
        display: none;
    }
`;

const totalHeight = 400;

export const MaskedHeaderWrapper = styled.div`
    height: ${totalHeight}vh;
    width: 100%;
    position: relative;
    overflow: visible;
    z-index: 8;
    pointer-events: none;

    &:not(.hasLoaded) {
        .video-ratio {
            opacity: 0 !important;
            transition: opacity.2s ease;
        }
    }

    &.isComplete {
        .above-fold-hint {
            position: absolute;
            top: auto;
            bottom: 0;
        }
        .masked-video {
            position: absolute;
            height: 100vh;
            width: 100%;
            bottom: 0;
            left: 0;
            z-index: 0;
        }
    }

    .perspective {
        perspective: 300vh;
        height: 100%;
        width: 100%;
        > div {
            height: 100%;
            width: 100%;
        }
    }

    .masked-video {
        pointer-events: none;
        position: fixed;
        width: 100vw;
        height: 100vh;
        bottom: 0;
        left: 0;
        video {
            height: 100%;
            width: 100%;
            object-fit: cover;
            aspect-ratio: 16 / 9;
        }
    }

    .above-fold-heading {
        pointer-events: none;
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        right: 0;
        z-index: 100;
        margin: 0;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        top: 45%;
        left: 0;
        height: auto;

        &.halfway {
            .title-1 {
                display: none;
            }
        }
    }

    .will-change-opacity {
        will-change: opacity;
        transform: translate3d(0, 0, 0);
    }

    .will-change-transform {
        will-change: transform;
        transform: translate3d(0, 0, 0);
    }

    .will-change-transform-opacity {
        will-change: opacity, transform;
        transform: translate3d(0, 0, 0);
    }
`;

export const BottomContent = styled.div<{$offsetHeight?: number}>`
    position: relative;
    z-index: 8;
    margin-top: -${p => p.$offsetHeight || 0}px;
`;
